export default {
  addFromMenu: "addFromMenu",
  somethingWentWrong: "somethingWentWrong",
  emptyItems: "emptyItems",
  itemSearchTitle: "itemSearchTitle",
  itemSearchPlaceholder: "itemSearchPlaceholder",
  itemCategoryTitle: "itemCategoryTitle",
  itemCategoryPlaceholder: "itemCategoryPlaceholder",
};
